/* @flow */

import React from 'react';

import IntlMessageComponent from 'components/formatters/intlMessage';

// CNLead sub types shown to the ISO
export const LEAD_TYPES = [
  { id: 3598, translationId: 'general.leads.leadtype.sellerflex' },
  { id: 3599, translationId: 'general.leads.leadtype.sellerfix' },
  { id: 3730, translationId: 'general.leads.leadtype.scfdebtor' }
];

type LeadTypeComponentProps = {
  id: number;
}

export default function LeadTypeComponent(props: LeadTypeComponentProps) {
  const leadType = LEAD_TYPES.find(lt => lt.id === props.id);

  if (!leadType) return null;
  return (<IntlMessageComponent id={leadType.translationId} />);
}
